import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Act } from '../model/recital';

export interface CreateActParams {
  name: string;
  description?: string;
  orderIndex?: number;
  duration?: number;
  notes?: string;
}

export const createActAPI = async (showId: string, params: CreateActParams) => {
  const response = await baseAPI.post<Act>(`/shows/${showId}/acts`, params);
  return response.data;
};

export const useCreateActMutation = () => {
  return useMutation({
    mutationFn: async ({
      showId,
      ...params
    }: CreateActParams & { showId: string }) => {
      return await createActAPI(showId, params);
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.SHOWS, variables.showId, KEYS.ACTS],
      });
    },
  });
};
